import { useLocale } from '../lib/i18n'
import { cn } from '../lib/utils'

const LABELS: Record<string, string> = { ar: 'ع', fr: 'FR' }

/** Toggle between Arabic and French. Uses a full navigation so <html dir> updates. */
export function LanguageSwitcher() {
  const { locale } = useLocale()

  return (
    <div className="inline-flex items-center rounded-full border border-ink-200 p-0.5 text-xs font-bold">
      {(['ar', 'fr'] as const).map((code) => (
        <a
          key={code}
          href={`/locale/${code}`}
          className={cn(
            'rounded-full px-2.5 py-1 transition-colors',
            locale === code ? 'bg-ink-900 text-white' : 'text-ink-500 hover:text-ink-900'
          )}
        >
          {LABELS[code]}
        </a>
      ))}
    </div>
  )
}
